import { isEmbedded } from '../../common/utils'

const EmbeddedHidden = ({ children }) => {
  return isEmbedded() ? null : children
}

export default EmbeddedHidden
